import { useState } from "react";
import { createModel } from "hox";
import { shipmentService } from "../../shipmentService";
import { IShipmentTabEnum, IShipmentDetailsAdded, IShipmentDetailMethod, IShipmentMaterial, IShipmentDetail, ILogistics, IShipmentAddedSettle, IShipmentBoxInfo } from "../../shimentTypes";
import useGlobalModel from "@/model/globalModel";
import { message } from "antd";
import moment from "moment";
import { useLockFn } from "ahooks";
import { formatNum, getRandomStr } from "@/utils/utils";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { ISettleParams } from "@/views/public/publicService";
import { ISaleSettlement } from "@/views/sales/salesTypes";
import { salesService } from "@/views/sales/salesService";
import { useDictModel } from "@/views/base/dict/dictModel";

//初始加收费用
const initAdded: IShipmentDetailsAdded = {
    key: "1",
    amount: "0",
    ename: "",
    name: "",
    status: DictCodeEnmu.SHIPMENT_PEND_SETTLE
}

//初始收汇方式
const initMethod: IShipmentDetailMethod = {
    key: "1",
    amount: "0",
    around: "",
    certificatesTime: "",
    collectionTime: "",
    paymentMethod: "",
    paymentTime: "",
    proportion: "",
}

export const initBoxInfo: IShipmentBoxInfo = {
    key: "1",
    containerCode: "",
    sealNum: "",
    driver: "",
    phone: "",
    licensePlate: "",
    date: "",
    note: "",
}
export const useShipmentDetailModel = createModel(function () {
    const { user: { shopCode, shopName } } = useGlobalModel(({ user }) => [user]);
    const { getTreeNodeValue } = useDictModel();
    const initFormVal = {
        id: "",
        code: "",
        shopName,
    };
    const [tabActive, setTabActive] = useState<IShipmentTabEnum>(IShipmentTabEnum.BASE_DETAIL) //tabs 选中
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<any>(initFormVal);
    const [editList, setEditList] = useState<any[]>([]);
    const [editAddedList, setEditAddedList] = useState<IShipmentDetailsAdded[]>([initAdded]);
    const [editAmounts, setEditAmounts] = useState<number>(0);  //商品总计
    const [editBoxList, setEditBoxList] = useState<IShipmentBoxInfo[]>([initBoxInfo]);  //装箱信息

    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);
    const [isSave, setIsSave] = useState<boolean>(true);  //加收费用是否编辑过，刷新才可结算

    //装柜详情
    const [boxDetailDialog, setBoxDetailDialog] = useState<boolean>(false);
    //添加加收费用
    const addAdded = (mode: string) => {
        setEditAddedList(origin => [...origin, {
            ...initAdded,
            key: getRandomStr()
        }])
    }

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
        }
        // setTabActive(IShipmentTabEnum.BASE_DETAIL);
    }

    /**
  * 根据贸易条款的选择 返回计算好的合同总金额 
  * 金额计算 四种情况
  */
    const clauseChange = (addedList: IShipmentDetailsAdded[]): number => {
        let contractAmount: number = 0;
        let clasueVal = editFormVal.clasue;
        let addedAmountToal: number = addedList.reduce((con, next) => { con = con + +(next.amount ?? 0); return con }, 0) ?? 0;

        // 贸易条款  FOB  采购总金额sum
        if (clasueVal === DictCodeEnmu.TRADE_FOB) {
            contractAmount = editAmounts;
        }
        // 贸易条款  CIF  采购总金额sum + 附加费（只取海运费） 
        else if (clasueVal === DictCodeEnmu.TRADE_CLF) {
            //查询是否存在海运费
            const hyAdded: IShipmentDetailsAdded | undefined = addedList.find(item => (item.name ?? "").indexOf("海运费") > -1);
            //取到海运费
            const hyMoney: number = +(hyAdded?.amount ?? 0)
            contractAmount = editAmounts + hyMoney;
        }
        // CFR  采购总金额sum + 附加费
        else if (clasueVal === DictCodeEnmu.TRADE_CFR) {
            contractAmount = editAmounts + addedAmountToal;
        }
        // 默认 采购总金额sum + 附加费
        else {
            contractAmount = editAmounts + addedAmountToal;
        };

        return contractAmount;
    }


    //主单修改
    const updateFormVal = (val?: object | null) => {
        setEditFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (val: IShipmentMaterial[]) => {
        setEditList([...val]);
    }

    //商品子表删除
    const removeMaterial = (selectedRowKeys: string[]) => {
        setEditList(origin => origin.filter(item => selectedRowKeys.indexOf(item.key) < 0));
    }

    //获取一条数据
    const getShipmentDetailOne = async (id: string) => {
        let { retData } = await shipmentService.one(id);
        let { details, detailsAdd, detailsPayment, detailsContainer, ...formVal } = retData;

        if (retData) {
            detailsAdd = detailsAdd ?? []
            detailsPayment = detailsPayment ?? []
            setEditFormVal({
                ...formVal,
                createTime:formVal.createTime ?moment(formVal.createTime):null,
                updateTime:formVal.updateTime ? moment(formVal.updateTime) :null,
                offerTime: formVal.offerTime ? moment(formVal.offerTime) : null,
                termTime: formVal.termTime ? moment(formVal.termTime) : null,
                batches: formVal.batches === "1" ? true : false, // "分批",
                transship: formVal.transship === "1" ? true : false // "转船",
            });
            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
            //加收费用  收汇方式  空初始一条数据
            setEditAddedList(detailsAdd.length > 0 ? detailsAdd.map(item => ({
                ...item,
                key: item.id ?? "",
                status: item.status ? item.status : DictCodeEnmu.SHIPMENT_PEND_SETTLE   //没有状态给默认状态
            })) : [initAdded]);
            setEditAmounts(details?.reduce((con, next) => { con = con + +(next.amount ?? 0); return con }, 0) ?? 0)
            setEditBoxList(detailsContainer?.map(item => ({
                ...item,
                key: item.id ?? getRandomStr(),
                date: item.date ? moment(item.date) : null,
            })) ?? []);
            setIsSave(true)
        }
        return retData;
    };

    //报价单新增 | 编辑
    const insertOrUpdateShipment = useLockFn(async (formVal: IShipmentDetail) => {
        let data = {
            ...editFormVal,
            ...formVal,
            shopCode,
            createTime: formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            updateTime: formVal.updateTime instanceof Object ? formVal.updateTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            batches: formVal.batches ? "1" : "0", // "分批",
            transship: formVal.transship ? "1" : "0", // "转船",
            offerTime: formVal.offerTime instanceof Object ? formVal.offerTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            termTime: formVal.termTime instanceof Object ? formVal.termTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            details: editList,
            detailsAdd: editAddedList,
            detailsContainer: editBoxList.map(item => ({
                ...item,
                date: item.date instanceof Object ? item.date.format('YYYY-MM-DDTHH:mm:ss') : null,
            }))
        };
        let { retData } = await shipmentService.update({ ...data, id: editFormVal.id });
        getShipmentDetailOne(editFormVal.code)
        message.success("保存成功")
        return retData;
    })

    /**
     * 物流进程
     */
    const [logFormVal, setLogFormVal] = useState<ILogistics>({});


    const getLogOne = async (code?: string) => {
        let { retData } = await shipmentService.oneLog(code ?? editFormVal.code);
        retData = retData ?? {};
        let data = {
            ...retData,
            testTime: retData.testTime ? moment(retData.testTime) : null,
            consignmentTime: retData.consignmentTime ? moment(retData.consignmentTime) : null,
            etd: retData.etd ? moment(retData.etd) : null,
            eta: retData.eta ? moment(retData.eta) : null,
            carryTime: retData.carryTime ? moment(retData.carryTime) : null,
            releaseTime: retData.releaseTime ? moment(retData.releaseTime) : null,
            shipmentTime: retData.shipmentTime ? moment(retData.shipmentTime) : null,
            ladingTime: retData.ladingTime ? moment(retData.ladingTime) : null,
            backTime: retData.backTime ? moment(retData.backTime) : null,
            presentationTime: retData.presentationTime ? moment(retData.presentationTime) : null,
            certificatesTime: retData.certificatesTime ? moment(retData.certificatesTime) : null,
            clearTime: retData.clearTime ? moment(retData.clearTime) : null,
            deliveryTime: retData.deliveryTime ? moment(retData.deliveryTime) : null,
            bookingTime: retData.bookingTime ? moment(retData.bookingTime) : null,
            declareTime: retData.declareTime ? moment(retData.declareTime) : null,
        }
        setLogFormVal(data);
        return data;
    };

    const insertOrUpdateLog = async () => {
        let data = {
            shipmentCode: editFormVal.code,
            ...logFormVal,
            testTime: logFormVal.testTime instanceof Object ? logFormVal.testTime.format('YYYY-MM-DD') : undefined,
            consignmentTime: logFormVal.consignmentTime instanceof Object ? logFormVal.consignmentTime.format('YYYY-MM-DD') : undefined,
            etd: logFormVal.etd instanceof Object ? logFormVal.etd.format('YYYY-MM-DD') : undefined,
            eta: logFormVal.eta instanceof Object ? logFormVal.eta.format('YYYY-MM-DD') : undefined,
            carryTime: logFormVal.carryTime instanceof Object ? logFormVal.carryTime.format('YYYY-MM-DD') : undefined,
            releaseTime: logFormVal.releaseTime instanceof Object ? logFormVal.releaseTime.format('YYYY-MM-DD') : undefined,
            shipmentTime: logFormVal.shipmentTime instanceof Object ? logFormVal.shipmentTime.format('YYYY-MM-DD') : undefined,
            ladingTime: logFormVal.ladingTime instanceof Object ? logFormVal.ladingTime.format('YYYY-MM-DD') : undefined,
            backTime: logFormVal.backTime instanceof Object ? logFormVal.backTime.format('YYYY-MM-DD') : undefined,
            presentationTime: logFormVal.presentationTime instanceof Object ? logFormVal.presentationTime.format('YYYY-MM-DD') : undefined,
            certificatesTime: logFormVal.certificatesTime instanceof Object ? logFormVal.certificatesTime.format('YYYY-MM-DD') : undefined,
            clearTime: logFormVal.clearTime instanceof Object ? logFormVal.clearTime.format('YYYY-MM-DD') : undefined,
            deliveryTime: logFormVal.deliveryTime instanceof Object ? logFormVal.deliveryTime.format('YYYY-MM-DD') : undefined,
            bookingTime: logFormVal.bookingTime instanceof Object ? logFormVal.bookingTime.format('YYYY-MM-DD') : undefined,
            declareTime: logFormVal.declareTime instanceof Object ? logFormVal.declareTime.format('YYYY-MM-DD') : undefined,
        }
        //入库时间
        if (data.deliveryTime) {
            data.status = DictCodeEnmu.SHIPMENT_WAREHOUSE
        }
        //清关
        else if (data.clearTime) {
            data.status = DictCodeEnmu.SHIPMENT_CUS
        }
        //交单/寄单
        else if (data.presentationTime) {
            data.status = DictCodeEnmu.SHIPMENT_PRESENT_BL
        }
        //提单
        else if (data.ladingTime) {
            data.status = DictCodeEnmu.SHIPMENT_BL
        }
        //装船
        else if (data.shipmentTime) {
            data.status = DictCodeEnmu.SHIPMENT_LADE
        }
        //报关放行
        else if (data.releaseTime) {
            data.status = DictCodeEnmu.SHIPMENT_DECLARE
        }
        //装柜
        else if (data.carryTime) {
            data.status = DictCodeEnmu.SHIPMENT_CONTAINER
        }
        //订舱
        else if (data.consignmentTime) {
            data.status = DictCodeEnmu.SHIPMENT_BOOK
        }
        //商检
        else if (data.testTime) {
            data.status = DictCodeEnmu.SHIPMENT_INSPECT
        } else {
            data.status = DictCodeEnmu.SHIPMENT_INIT
        }

        //存在id  编辑
        if (logFormVal.id) {
            let { retData } = await shipmentService.updateLog(data);
            message.success("保存成功");
            updateFormVal({ status: data.status })
            return retData;
        } else {
            let { retData } = await shipmentService.insertLog(data);
            message.success("物流进程生成成功")
            getLogOne()
            updateFormVal({ status: data.status })
            return retData;
        }
    };

    /**
     * 结算
     */
    const [settleVisible, setSettleVisible] = useState<IShipmentAddedSettle>({
        visible: false,
        addedRow: null
    });

    const shipmentSettle = useLockFn(async (val: ISettleParams) => {
        let data: ISettleParams = {
            ...val,
            shopCode,
        };
        let { retData, retMsg } = await shipmentService.settle(data);
        if (retData) {
            message.success("结算成功")
            setSettleVisible({
                visible: false,
                addedRow: null
            });
            getShipmentDetailOne(editFormVal.code)
        } else {
            message.warning(retMsg)
        }
    });

    //收汇、结汇
    const receiptSettle = useLockFn(async (data: ISaleSettlement[], ioFlag = 0) => {
        // let { retData } = await salesService.receiptSettle(data);
        let { retData: statu } = await shipmentService.settle({
            shopCode,
            id: settleVisible.addedRow?.id ?? "",
            amount: data[0].settlePrice,
            settleTime: data[0].settleTime
        } as ISettleParams);
        if (statu) {
            message.success("操作成功")
            setSettleVisible({
                visible: false,
                addedRow: null
            });
            getShipmentDetailOne(editFormVal.code)
        }
    });
    //转运输
    const transferInvoices = useLockFn(async () => {
        let { retData } = await shipmentService.transferInvoices({
            shopCode, code: editFormVal.code
        });
        message.success("操作成功")
        return retData;
    });

    //获取币种符号
    const getcurrencySymbol = (mode: string) => {
        let currencyCode: string | undefined = mode === "edit" ? editFormVal.currencyCode : ""
        if (!currencyCode) return ""
        return getTreeNodeValue(currencyCode);
    }
    return {
        /***field***/
        editFormVal,
        editList,
        initAdded,
        initMethod,
        editAmounts,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        editAddedList, setEditAddedList,
        editBoxList, setEditBoxList,
        boxDetailDialog, setBoxDetailDialog,
        /***method***/
        updateFormVal,
        updateList,
        removeMaterial,
        // insertMaterial,
        resetPageCache,
        addAdded,
        getShipmentDetailOne,
        insertOrUpdateShipment,
        //**************** */
        logFormVal, setLogFormVal,
        getLogOne, insertOrUpdateLog,
        settleVisible, setSettleVisible,
        clauseChange,
        shipmentSettle,
        isSave, setIsSave,
        receiptSettle, transferInvoices, getcurrencySymbol
    }
});